import { Eye, SignOut } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

export default function ImpersonationBanner() {
  const { impersonating, exitImpersonation } = useAuth();
  if (!impersonating) return null;
  return (
    <div data-testid="impersonation-banner"
      className="fixed top-0 inset-x-0 z-[60] flex items-center justify-center gap-3 px-4 py-2 bg-gradient-to-r from-[#B08D57] to-[#8A6D2E] text-[#1A1715] shadow-[0_6px_20px_-6px_rgba(74,0,0,0.5)]">
      <Eye size={17} weight="fill" className="shrink-0" />
      <p className="text-sm font-semibold truncate">
        Viewing as <span className="font-extrabold">{impersonating.name}</span>
        <span className="hidden sm:inline font-normal opacity-80"> · every change is saved as this user and audited to you</span>
      </p>
      <button data-testid="exit-impersonation-btn" onClick={exitImpersonation}
        className="ml-1 inline-flex items-center gap-1.5 rounded-full bg-[#4A0000] text-white text-xs font-bold px-3 py-1.5 hover:bg-[#5C1A1A] transition-colors shrink-0">
        <SignOut size={14} weight="bold" /> Exit
      </button>
    </div>
  );
}
